import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  StatusFormatter,
  dateDefault,
  formLabelsTheme,
  formatDate,
  formatQuantity,
  formatterStatus,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  statusInboundFormatter,
  useStyles,
  useStylesReddit,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  selectParameter,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editStocktake,
  editStocktakeConfirm,
  editStocktakeSetstatus,
  fetchIdStocktake,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectIdStocktake,
  fetchStocktakeVehicle,
  selectStocktakeVehicle,
  removeStocktakeVehicle,
  editStocktakeStarWorkflow,
  editStocktakeAmend,
  addStocktakeVehicle,
  editStocktakeAmmend,
  editStocktakeComplete,
  setPermisionList,
  setPermisionCount,
} from "./stocktakeSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";

import { Autocomplete } from "@material-ui/lab";
import { ModalCancel } from "./ModalCancel";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";

// import { ModalCreateVehicle } from "./ModalCreateVehicle";
// import { ModalCreateParty } from "./ModalCreateParty";
// import { StocktakeCancel } from "./StocktakeCancel";
// import { ModalEditVehicle } from "./ModalEditVehicle";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const StocktakeEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdStocktake);
  const dataVehicle = useSelector(selectStocktakeVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataJobType = useSelector(selectParameter);

  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);

  const [vehiclesFilter, setVehiclesFilter] = useState("");
  const [vehiclesFilterValue, setVehiclesFilterValue] = useState("");
  const [row, setRow] = useState(null);
  const [getData, setGetData] = useState(false);

  const [showGenerate, setShowGenerate] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [typeParty, setTypeParty] = useState("");

  const [list, setList] = useState([]);
  const dataMenuTab = useSelector(selectMenuTab);

  //
  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    job_date: {
      value: dateDefault,
      error: false,
      required: "Y",
    },
    ete: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    ets: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    service_class: {
      value: "",
      error: false,
      required: "Y",
    },
    criteria: {
      value: "ALL_STOCK",
      error: false,
      required: "Y",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    criteria_value: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  // formVehicle
  const [formVehicle, setFormVehicle] = useState({
    party_id: {
      value: "",
      error: false,
      required: "N",
    },
    party_name: {
      value: "",
      error: false,
      required: "N",
    },
    party_code: {
      value: "",
      error: false,
      required: "N",
    },
    timezone: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchParameter({
          paramgroup_code: "CRITERIA",
          pageNo: 1,
          pageSize: -1,
        })
      );

      await dispatch(fetchIdStocktake(id));
      await dispatch(
        fetchMenuTab({
          menu_url: "/motor-pool/stocktake",
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        ...formValues,
        client: {
          value: dataId.client,
          error: false,
          required: "Y",
        },
        client_name: {
          value: dataId.client_name,
          error: false,
          required: "Y",
        },
        job_date: {
          value:
            dataId.job_date === null
              ? null
              : moment(dataId.job_date).format("YYYY-MM-DD"),
          error: false,
          required: "Y",
        },
        ets: {
          value:
            dataId.estimated_start === null
              ? null
              : moment(dataId.estimated_start).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        ete: {
          value:
            dataId.estimated_end === null
              ? null
              : moment(dataId.estimated_end).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        service_class: {
          value: dataId.service_class_name,
          error: false,
          required: "Y",
        },
        criteria: {
          value: dataId.criteria,
          error: false,
          required: "Y",
        },
        criteria_value: {
          value: dataId.criteria_value,
          error: false,
          required: dataId.criteria === "ALL_STOCK" ? "N" : "Y",
        },

        remarks: {
          value: dataId.remarks,
          error: false,
          required: "N",
        },
        value: {
          value: dataId.value,
          error: false,
          required: "N",
        },
      });

      dispatch(
        fetchStocktakeVehicle({
          stocktake_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
  }, [dataId]);

  console.log(formValues, "data");

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Count") {
          return dispatch(setPermisionCount(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  // HanldeSave

  const handleSave = async () => {
    console.log(formValues, "formValues");
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = {
      stocktake_id: id,
      client: formValues.client.value,
      job_date: formValues.job_date.value,
      estimated_start: formValues.ets.value,
      estimated_end: formValues.ete.value,
      services_class: formValues.service_class.value,
      criteria: formValues.criteria.value,
      // criteria_type: formValues.criteria.value,
      criteria_value:
        formValues.criteria.value === "ALL_STOCK"
          ? ""
          : formValues.criteria_value.value,
      remarks: formValues.remarks.value,
    };

    try {
      const response = await dispatch(editStocktake(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const [showClient, setShowClient] = useState(false);
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [showShipper, setShowShipper] = useState(false);

  const [typeLocation, setTypeLocation] = useState("");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setVehiclesFilter("");
    } else {
      setVehiclesFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let params = {};

    params.stocktake_id = id;
    params[vehiclesFilter] = vehiclesFilterValue;
    params.pageNo = 1;
    params.pageSize = 10;

    try {
      const response = await dispatch(fetchStocktakeVehicle(params));
      if (response.payload.data.status === 200) {
        await window.scrollTo(0, 850);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};

      params[vehiclesFilter] = vehiclesFilterValue;
      params.stocktake_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchStocktakeVehicle(params));
        if (response.payload.data.status === 200) {
          await window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const handleDelete = async (e, row) => {
    const params = { stocktakevehicle_id: `${row.stocktakevehicle_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeStocktakeVehicle({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          if (action.isConfirmed)
            await dispatch(
              fetchStocktakeVehicle({
                stocktake_id: id,
                pageNo: 1,
                pageSize: paginationSet,
              })
            );
          await window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {dataId.stocktake_status === "5410" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => handleDelete(e, row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Current Location",
      dataField: "current_location",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      headerAlign: "center",
    },
    {
      text: "Vehicle Status",
      dataField: "vehicle_status_mpc",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
  ];

  // modal Create vehicle
  const [showVehicle, setShowVehicle] = useState(false);
  const [showVehicleEdit, setShowVehicleEdit] = useState(false);
  const [showUpload, setShowUpload] = useState(false);

  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [showCancel, setShowCancel] = useState(false);

  const handleConfirm = async () => {
    const params = {
      stocktake_id: id,
    };
    try {
      const response = await dispatch(editStocktakeConfirm(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleAmend = async () => {
    const params = {
      stocktake_id: id,
    };
    try {
      const response = await dispatch(editStocktakeAmmend(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleComplete = async () => {
    const params = {
      stocktake_id: id,
      stocktake_status: "5415",
    };
    try {
      const response = await dispatch(editStocktakeComplete(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  // handle UPload File
  const [showUploadView, setShowUploadView] = useState(false);
  const [rowUpload, setRowUpload] = useState(null);
  const [rowUploadStatus, setRowUploadStatus] = useState(null);

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUploadStatus(row.status);
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      </div>
    );
  };
  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  // modal party
  const [showParty, setShowParty] = useState(false);
  const [partyType, setPartyType] = useState(false);
  const [rowParty, setRowParty] = useState(null);

  const [selectedVehicle, setSelectedVehicle] = useState([]);

  const columnsWorkflow = [
    {
      text: "Activity",
      dataField: "activity",
    },

    {
      text: "Planned",
      dataField: "planned",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Unplanned",
      dataField: "unplanned",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Pending",
      dataField: "pending",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Completed",
      dataField: "completed",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Status",
      dataField: "status",
    },
  ];

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (list.includes(row.activity)) {
        if (row.activity === "Count" && dataId.stocktake_status === "5414") {
          history.push(`/motor-pool/stocktake/workflow/edit/${id}`, 0);
        }
        if (row.activity === "Count" && dataId.stocktake_status === "5415") {
          history.push(`/motor-pool/stocktake/workflow/edit/${id}`, 0);
        }
      }
    },
  };

  const handleStart = async () => {
    const params = {
      stocktake_id: id,
      stocktake_status: "6140",
    };
    try {
      const response = await dispatch(editStocktakeStarWorkflow(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const jobTypeOptions = dataJobType.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const indexCriteria = jobTypeOptions.findIndex(
    (obj) => obj.value === formValues.criteria.value
  );

  const handleChangeJobType = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["criteria"]: {
        ...formValues["criteria"],
        value,
      },
      criteria_value: {
        value: formValues.criteria_value.value,
        error: false,
        required: value === "ALL_STOCK" ? "N" : "Y",
      },
    });
  };

  const handleGenerateList = async (e) => {
    const params = [
      {
        stocktake_id: id,
        criteria_type: formValues.criteria.value,
        criteria_value: formValues.criteria_value.value,
      },
    ];

    console.log(params, "params");

    try {
      const response = await dispatch(addStocktakeVehicle(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
        await window.scrollTo(0, 850);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Stocktake : {dataId.stocktake_no}
                </p>
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest text-center  text-white">
                  Job Date :{formatDate(dataId.job_date)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  Client : {dataId.client_name}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white ">
                  Status :{" "}
                  {statusInboundFormatter(dataId.stocktake_status_name)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  <Dropdown>
                    <Dropdown.Toggle className="primary" id="dropdown-basic">
                      Action
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {dataId.stocktake_status === "5410" && (
                        <>
                          <Dropdown.Item onClick={(e) => setShowConfirm(true)}>
                            Confirm
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={(e) => {
                              setShowCancel(true);
                            }}
                          >
                            Cancel
                          </Dropdown.Item>
                        </>
                      )}

                      {dataId.stocktake_status === "5413" &&
                        dataId.is_amend === "Y" && (
                          <Dropdown.Item onClick={handleAmend}>
                            Amend
                          </Dropdown.Item>
                        )}
                      {dataId.stocktake_status === "5413" && (
                        <Dropdown.Item onClick={handleComplete}>
                          Complete
                        </Dropdown.Item>
                      )}
                      {dataId.stocktake_status === "5414" && (
                        <Dropdown.Item onClick={handleComplete}>
                          Complete
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <ThemeProvider theme={formLabelsTheme}>
                <>
                  {/* Basic Detail */}
                  <div className="ml-2 mt-5">
                    <p className="font-weight-boldest">Basic Detail</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Job Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date"
                          value={formValues.job_date.value}
                          onChange={handleChange}
                          error={formValues.job_date.error}
                          helperText={
                            formValues.job_date.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                          disabled={
                            dataId.stocktake_status !== "5410" ? true : false
                          }
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Service Class"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          name="services_class"
                          value={dataId.services_class_name}
                          disabled
                        />
                        <RedditTextField
                          label="Job Type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="text"
                          size="small"
                          fullWidth
                          name="job_type"
                          value={"Stock Take"}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>

                  {/*Criteria*/}
                  <div className="ml-2 mt-5">
                    <p className="font-weight-boldest">Criteria</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Autocomplete
                          disablePortal
                          name="criteria"
                          options={jobTypeOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={handleChangeJobType}
                          value={jobTypeOptions[indexCriteria]}
                          disabled={
                            dataId.stocktake_status !== "5410" ? true : false
                          }
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Criteria"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="criteria"
                              error={formValues.criteria.error}
                              helperText={
                                formValues.criteria.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                            />
                          )}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {formValues.criteria.value !== "ALL_STOCK" && (
                          <RedditTextField
                            required
                            label="Value"
                            className={classes.margin}
                            variant="filled"
                            id="reddit-input"
                            fullWidth
                            size="small"
                            name="criteria_value"
                            value={formValues.criteria_value.value}
                            onChange={handleChange}
                            disabled={
                              dataId.stocktake_status !== "5410" ? true : false
                            }
                            error={formValues.criteria_value.error}
                            helperText={
                              formValues.criteria_value.error ? (
                                <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                  {iconError} {"This field is required"}
                                </FormHelperText>
                              ) : (
                                ""
                              )
                            }
                          />
                        )}

                        {dataId.stocktake_status === "5413" && (
                          <Row className="mt-6 justify-content-end">
                            <Button
                              variant="primary"
                              onClick={(e) => setShowGenerate(true)}
                            >
                              Generate List
                            </Button>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </div>

                  <hr />

                  {/* Packages */}
                  <div>
                    <p className="font-weight-boldest">Packages</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Total Vehicles </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_vehicle}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Net Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_netweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <RedditTextField
                          label="Remarks"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="remarks"
                          value={formValues.remarks.value}
                          inputProps={{ maxLength: 150 }}
                          onChange={handleChange}
                          disabled={
                            dataId.stocktake_status !== "5410" ? true : false
                          }
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Volume </b>
                          </Form.Label>
                          <Col sm={6}>
                            {" "}
                            <Form.Label className="mt-2">
                              <b>{dataId.total_volume}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Gross Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_grossweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  {/* handleSave */}
                  {dataId.stocktake_status === "5410" && (
                    <Row className="mt-6 justify-content-end">
                      <Button variant="primary" onClick={handleSave}>
                        Save
                      </Button>
                    </Row>
                  )}

                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">Vehicle</p>
                    <div className="d-flex justify-content-end">
                      <div className="p-2 mt-3">Search By</div>
                      <div className="p-2" style={{ width: "180px" }}>
                        {" "}
                        <Select
                          options={vehiclesOptions}
                          value={getValueOptions(
                            vehiclesFilter,
                            vehiclesOptions
                          )}
                          placeholder="Select"
                          onChange={handleChangeVehicles}
                          required
                        />
                      </div>
                      <div className="p-2">
                        <Form.Control
                          type="text"
                          placeholder=""
                          onChange={(e) =>
                            setVehiclesFilterValue(e.target.value)
                          }
                          value={vehiclesFilterValue}
                        />
                      </div>
                      <div className="p-2">
                        {" "}
                        <Button variant="primary" onClick={handleSearch}>
                          Search
                        </Button>
                      </div>
                    </div>

                    {/* table */}

                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="vehicle_id"
                      data={dataVehicle}
                      columns={columns}
                      pagination={paginationFactory(options)}
                      onTableChange={handleTableChange}
                      hover
                    ></BootstrapTable>

                    {dataId.Stocktake_status === "5410" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary mr-3"
                          onClick={(e) => {
                            setFileName("Upload Template File");
                            setFile(null);
                            setSelectedRows([]);
                            setTableData([]);
                            setShowUpload(true);
                          }}
                        >
                          Upload Vehicle
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={(e) => {
                            setGetData(true);
                            setShowVehicle(true);
                          }}
                        >
                          Add Vehicle
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">
                      Workflow of Stocktake Job
                    </p>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="no"
                      data={
                        dataId.workFlowStockTakeJobs === null
                          ? []
                          : dataId.workFlowStockTakeJobs
                      }
                      columns={columnsWorkflow}
                      rowEvents={rowEvents}
                      hover
                    />
                  </div>
                </>
              </ThemeProvider>
            </CardBody>
          </Card>
          {/* generate list */}
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showGenerate}
            onHide={(e) => setShowGenerate(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Generate List
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <p>
                  You are about to generate the list of vehicles for stock-take
                  job No : <b>{dataId.stocktake_no}</b>, <br />
                  this action cannot be undone!
                  <br />
                  Are you sure want to generate list for this job?
                </p>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={(e) => setShowGenerate(false)}
              >
                Close
              </Button>
              <Button variant="primary" onClick={handleGenerateList}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          {/* confrim  */}
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showConfirm}
            onHide={(e) => setShowConfirm(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Confirm Stock Take Job
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <p>
                  You are about to confirm stock-take job No:{" "}
                  <b>{dataId.stocktake_no}</b>, <br />
                  this action cannot be undone!
                  <br />
                  Are you sure want to confirm this?
                </p>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={(e) => setShowConfirm(false)}
              >
                Close
              </Button>
              <Button variant="primary" onClick={handleConfirm}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>
          <ModalCancel
            isOpen={showCancel}
            setShow={setShowCancel}
            id={id}
            name={dataId.stocktake_o}
          />
        </>
      )}
    </>
  );
};
